<script lang="ts">
  import UnscheduledTable from "./unscheduled-table.svelte";
  import {
    isClosedStatus,
    isDisplayedStatus,
    groupByStatus,
    statusOrder
  } from "../../domain/status";
  import { getNow } from "../../data/clock";

  export let time = getNow();
  export let places = [];
  export let showSubtitle = false;

  $: byStatus = groupByStatus(places, $time);
</script>

{#each statusOrder as status}
  {#if isDisplayedStatus(status)}
    <UnscheduledTable
      title="status.{status}"
      entries={byStatus[status]}
      muted={isClosedStatus(status)}
      showTitle={isClosedStatus(status)}
      {time}
      {showSubtitle}
    />
  {/if}
{/each}
